import {Term} from '../../terms/components/TermsComponent';

export const retentionOfData: Term[] = [
  {
    id: '6.1',
    term:
      'We will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our legal agreements and policies. We will also retain Usage Data for internal analysis purposes.',
  },
];
